<div class="modal-header">
    <h4 class="modal-title">Uniconta settings</h4>
    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div *ngIf="officeSettings$ | async as officeSettings" class="modal-body">
    <div class="mb-3">
        <label for="unicontaCompanyId">Uniconta Company ID</label>
        <input (blur)="updateSetting(officeSettings.unicontaCompanyId, $event, '/unicontaCompanyId')"
               [value]="officeSettings.unicontaCompanyId"
               type="text"
               class="form-control"
               id="unicontaCompanyId">
    </div>
    <div class="mb-3">
        <label for="unicontaApiUsername">Uniconta API username</label>
        <input (blur)="updateSetting(officeSettings.unicontaApiUsername, $event, '/unicontaApiUsername')"
               [value]="officeSettings.unicontaApiUsername"
               type="text"
               class="form-control"
               id="unicontaApiUsername">
    </div>
    <div class="mb-3">
        <label for="unicontaApiPassword">Uniconta API password</label>
        <input (blur)="updateSetting('', $event, '/unicontaApiPassword')"
               type="password"
               class="form-control"
               id="unicontaApiPassword">
        <small *ngIf="officeSettings.unicontaApiPassword" class="form-text text-body-secondary">Password er sat men vises ikke!</small>
    </div>
</div>
